import { TableConfig } from "../../../../../common/tables/config/TableConfig";
import { VariantTableRow } from "../../../../../../../common/tables/product-listing/variants/VariantTableRow";
import { SortOrder } from "../../../../../../../common/query-filters";
import { CellType } from "../../../../../common/tables/config/CellType";

/**
 * Read-only variant table config for the CostMetadata variant assignment side sheet.
 * Shows a leading "Assigned" checkbox column followed by variant details.
 * The costMetadataCount column is repurposed as the checkbox assignment field.
 */
export const DefaultCostMetadataVariantSideSheetConfig: TableConfig<VariantTableRow> = {
    columns: [
        {
            columnName: "costMetadataCount",
            displayName: "Assigned",
            cellType: CellType.checkbox,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "90px",
            textAlign: "center",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "id",
            displayName: "Variant ID",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "130px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "title",
            displayName: "Title",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "220px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "sku",
            displayName: "SKU",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "180px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "price",
            displayName: "Price",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "100px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "inventoryQuantity",
            displayName: "Quantity",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "100px",
            sortable: false,
            filterable: false,
        },
    ],
    filters: {
        expressions: [],
        sortOrder: SortOrder.ASCENDING,
        sortColumn: "sku",
        pageSize: 50,
    },
};
